import * as Parse from 'parse'

import { Component } from '@angular/core'
import { UntypedFormControl, Validators } from '@angular/forms'
import { MatDialogRef } from '@angular/material/dialog'
import { MatSnackBar } from '@angular/material/snack-bar'

@Component({
    selector: 'app-invalid-session-dialog',
    templateUrl: './invalid-session.component.html',
    styleUrls: ['./invalid-session.component.scss'],
    standalone: false,
})
export class InvalidSessionDialogComponent {
    passwordControl = new UntypedFormControl('', Validators.required)
    isLoggingIn = false

    constructor(
        private dialog: MatDialogRef<InvalidSessionDialogComponent>,
        private snackBar: MatSnackBar
    ) {}

    async onLogInClicked() {
        try {
            const password = (this.passwordControl.value ?? '').trim()
            if (!password) {
                return
            }
            this.isLoggingIn = true
            await Parse.User.logIn(Parse.User.current()?.getUsername() ?? '', password)
            this.dialog.close(true)
        } catch (err) {
            this.snackBar.open(err.message, undefined, { duration: 5000, panelClass: ['error'] })
        }
        this.isLoggingIn = false
    }
}
